module.exports = __webpack_public_path__ + "static/together_bg4-91061505ff19b40ffe7bdfde9c28d251.png";